import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RuleItemEditFormData } from "../../state/SearchManager/RuleItemEditFormData";
import { shallowValidationCheck } from '../../../utils/ValidationUtils';

const updateRuleItemEditForm: Reducer<RuleItemEditFormData> = (state: RuleItemEditFormData = new RuleItemEditFormData(), action: Action<ActionType, RuleItemEditFormData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_DATA_FETCHED:
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_UPDATED:
      return { ...state, data: { ...state.data, ...action.data } };
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_WARNINGS_FETCHED:
      return { ...state, warnings: { ...action.data }, validation: {} };
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_VALIDATED:
      let isValid = shallowValidationCheck(action.data);
      return { ...state, validation: action.data, readyToFetchWarningsBeforeSave: isValid, warnings: {} };
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_SAVED:
      return { ...state, readyToFetchWarningsBeforeSave: false };
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_SET_BEFORE_SAVE:
      return { ...state, readyToFetchWarningsBeforeSave: action.data };
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_CLEAR_WARNINGS:
      return { ...state, warnings: {} };
    case ActionType.SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_RESET:
      return new RuleItemEditFormData();
    default:
      return state;
  }
};

export default updateRuleItemEditForm;